import './ViewerItem.sass';

import React, { FC, useEffect, useRef } from 'react';
import { animated } from '@react-spring/web';
import { ViewerItemProps } from './ViewerItem.interface';
import { classNames as cn } from '$utils';
import { useThumbHash } from '$hooks';
import { getFitSize } from '../zoom';

export const ViewerItem: FC<ViewerItemProps> = ({
  item,
  active,
  mobile,
  viewWidth,
  viewHeight,
  zoom,
}) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const placeholder = useThumbHash(item.thumbHash, item.thumbnail);
  const isVideo = item.id < 0;
  const fullscreen = isVideo && mobile;
  const { width, height } = getFitSize(item, viewWidth, viewHeight, mobile);
  const zoomStyle = zoom && !isVideo ? zoom : undefined;

  useEffect(() => {
    if (!active && videoRef.current?.pause) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
    }
  }, [active]);

  return (
    <div className={cn('ViewerItem')} style={{ width: viewWidth, height: viewHeight }}>
      <animated.div
        className="ViewerItem__photo"
        style={{
          ...zoomStyle,
          width: (fullscreen ? viewWidth : width) + 'px',
          height: (fullscreen ? viewHeight : height) + 'px',
        }}
      >
        {isVideo ? (
          <video
            ref={videoRef}
            onClick={(e) => e.stopPropagation()}
            width="100%"
            height="100%"
            src={item.source}
            poster={placeholder}
            controls
            autoPlay
            playsInline
          />
        ) : (
          <img
            src={item.source}
            style={{ backgroundImage: `url('${placeholder}')` }}
            alt=""
          />
        )}
      </animated.div>
    </div>
  );
};
